<template>
	<div class="curve" ref="echarts"></div>
</template>

<script>
import { downloadFile } from "../../../util/fileUtil"
const echarts = require("echarts");
export default {
	name: "Curve",
	props: ["chartsData"],
	data() {
		return {
			myChart: null,
			newobj: null
		}
	},
	computed: {
		diagramStatus() {
			return this.$store.state.project.diagramStatus
		},
		routeName() {
			return this.$route.params.name
		},
		tag() {
			return this.$route.params.tag
		},
	},
	watch: {
		diagramStatus(n) {
			if (n.type === 'echarts') {
				let data = this.myChart.getDataURL({
					type: "png",
					backgroundColor: "#fff",
					pixelRatio: 2,
				})

				let name = ''
				if (this.tag === 'CapacitanceCompensation') {
					name = '谐波分析'
				}

				downloadFile(name + new Date().toLocaleString(), data)
			}
		},
		chartsData(n, o) {
			this.myChart.clear()
			let obj = {
				tooltip: n.tooltip,
				xAxis: {
					type: 'category',
					data: n.xAxis.data,

					axisTick: {
						show: false
					},
					axisLabel: {
						fontSize: 12,
						color: "#333",
						fontWeight: 'bold'
					}
				},
				grid: {
					left: "0%",
					right: "3%",
					bottom: "0%",
					top: "20%",
					containLabel: true,
				},

				title: {
					text: n.yAxis.name,
					textAlign: "left",
					left: -5,// 距离左边位置
					// top: -5,// 距离上面位置
					textStyle: {
						align: "left",
						fontWeight: 'bold',
						fontSize: 12,
						color: "#333",
						fontStyle: 'italic'
					}
				},
				legend: n.legend,
				color: n.color,
				yAxis: {
					type: 'value',
					// name: this.chartsData.yAxis.name,
					nameTextStyle: {
						align: "right",
						fontWeight: 'bold',
						// fontSize: 16,
						fontStyle: "italic",
						color: "#333",
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
						}
					},
					axisLabel: {
						fontSize: 12,
						color: "#333",
						fontWeight: 'bold'
					}
				},
				series: n.series
			};
			this.myChart.setOption(obj);
		},
	},
	mounted() {
		let myChart = echarts.init(this.$refs.echarts);
		this.myChart = myChart
		let obj = {
			tooltip: this.chartsData.tooltip,
			xAxis: {
				type: 'category',
				data: this.chartsData.xAxis.data,

				axisTick: {
					show: false
				},
				axisLabel: {
					fontSize: 12,
					color: "#333",
					fontWeight: 'bold'
				}
			},
			grid: {
				left: "0%",
				right: "3%",
				bottom: "0%",
				top: "20%",
				containLabel: true,
			},

			title: {
				text: this.chartsData.yAxis.name,
				textAlign: "left",
				left: -5,// 距离左边位置
				// top: -5,// 距离上面位置
				textStyle: {
					align: "left",
					fontWeight: 'bold',
					fontSize: 12,
					color: "#333",
					fontStyle: 'italic'
				}
			},
			legend: this.chartsData.legend,
			color: this.chartsData.color,
			yAxis: {
				type: 'value',
				// name: this.chartsData.yAxis.name,
				nameTextStyle: {
					align: "right",
					fontWeight: 'bold',
					// fontSize: 16,
					fontStyle: "italic",
					color: "#333",
				},
				splitLine: {
					show: true,
					lineStyle: {
						type: 'dashed',
					}
				},
				axisLabel: {
					fontSize: 12,
					color: "#333",
					fontWeight: 'bold'
				}
			},
			series: this.chartsData.series
		};
		this.newobj = obj
		this.myChart.setOption(obj, true);

		window.addEventListener("resize", () => {
			this.myChart.resize();
		});
	},
	methods: {
		merge(o1, o2) {
			for (const key in o2) {
				if (Object.hasOwnProperty.call(o2, key) && o1[key]) {
					if (typeof o2[key] === 'object' && typeof o1[key] === 'object') {
						this.merge(o1[key], o2[key])
					} else {
						o1[key] = o2[key]
					}

				} else {
					o1[key] = o2[key]
				}
			}
		}
	}
}
</script>

<style scoped lang="less">
.curve {
	width: 100%;
	height: 100%;
}
</style>